export var ExternalBalanceProviderEnum;
(function (ExternalBalanceProviderEnum) {
    ExternalBalanceProviderEnum["BITGET"] = "BITGET";
    ExternalBalanceProviderEnum["BITGET_INTERNAL"] = "BITGET_INTERNAL";
    ExternalBalanceProviderEnum["BTSE"] = "BTSE";
    ExternalBalanceProviderEnum["BTSE_INTERNAL"] = "BTSE_INTERNAL";
    ExternalBalanceProviderEnum["BYBIT"] = "BYBIT";
    ExternalBalanceProviderEnum["BYBIT_INTERNAL"] = "BYBIT_INTERNAL";
    ExternalBalanceProviderEnum["FIREBLOCKS"] = "FIREBLOCKS";
    ExternalBalanceProviderEnum["KRAKEN"] = "KRAKEN";
    ExternalBalanceProviderEnum["WHITEBIT"] = "WHITEBIT";
    ExternalBalanceProviderEnum["WHITEBIT_INTERNAL"] = "WHITEBIT_INTERNAL";
})(ExternalBalanceProviderEnum || (ExternalBalanceProviderEnum = {}));
//# sourceMappingURL=external-balance-provider.enum.js.map